import { styled, Flex } from '@chilipiper/design-system'

export const StyledHeaderContainer = styled(Flex)`
  @media (max-width: ${props => props.theme.breakpoints[0]}) {
    background:
      linear-gradient(0deg, rgba(207, 218, 226, 0.16), rgba(207, 218, 226, 0.16)), #ffffff;
  }
`
